import { render, staticRenderFns } from "./AiLanguageModal.vue?vue&type=template&id=30eabce3"
import script from "./AiLanguageModal.vue?vue&type=script&lang=js"
export * from "./AiLanguageModal.vue?vue&type=script&lang=js"
import style0 from "./AiLanguageModal.vue?vue&type=style&index=0&id=30eabce3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports